// msalConfig.js — Redirect-only, frontend-only sign-in
import { LogLevel } from "@azure/msal-browser";

const tenantId    = process.env.REACT_APP_AZURE_TENANT_ID;
const clientId    = process.env.REACT_APP_AZURE_CLIENT_ID;
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;

if (!tenantId) throw new Error("REACT_APP_AZURE_TENANT_ID is not set");
if (!clientId) throw new Error("REACT_APP_AZURE_CLIENT_ID is not set");

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii && level >= LogLevel.Warning) console.warn("[MSAL]", message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
